{
  "name": "visa-platform",
  "version": "2.1.2",
  "private": true,
  "author": "engage-frontend@razorpay.com",
  "engines": {
    "node": ">=18.20.1"
  }
}
